module.exports = "/_next/static/images/american-express-7979157e8d3192b21c73ad001e9802ae.svg";